export default "__VITE_ASSET__BLUyVKAK__"